import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { RevealText, FadeUp } from "./Reveal";
import { useI18n } from "@/context/Language";

export const Hero = ({ onDonate }) => {
  const { t, N } = useI18n();
  const HERO = t.hero;

  return (
    <section id="top" className="relative min-h-screen w-full overflow-hidden pt-[72px]">
      <div className="max-w-7xl mx-auto px-6 sm:px-8 pt-14 lg:pt-20 pb-20">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-6 lg:items-center">
          <div className="lg:col-span-6 relative z-20 lg:pt-8">
            <FadeUp delay={0.1}>
              <span className="text-xs sm:text-sm font-medium uppercase tracking-[0.24em] text-terracotta">
                {HERO.overline}
              </span>
            </FadeUp>

            <RevealText
              lines={HERO.lines}
              delay={0.3}
              className="mt-6 font-serif text-5xl sm:text-6xl lg:text-7xl font-medium tracking-tight leading-[0.92] text-ink"
            />

            <FadeUp delay={0.9} className="mt-8 max-w-md">
              <p className="text-base sm:text-lg leading-relaxed text-ink/70">{HERO.body}</p>
            </FadeUp>

            <FadeUp delay={1.05} className="mt-9 flex flex-wrap items-center gap-4">
              <button
                data-testid="hero-donate-button"
                onClick={() => onDonate()}
                className="group inline-flex items-center gap-2 rounded-full bg-terracotta px-7 py-3.5 text-sm font-semibold text-sand transition-colors hover:bg-terracotta-hover active:scale-[0.98]"
              >
                {HERO.donateNow}
                <ArrowUpRight className="h-4 w-4 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
              </button>
              <a href="#story" data-testid="hero-story-link" className="text-sm font-semibold text-ink underline decoration-terracotta/40 underline-offset-4 hover:decoration-terracotta transition-colors">
                {HERO.readStory}
              </a>
            </FadeUp>
          </div>

          <div className="lg:col-span-6 relative">
            <motion.div
              initial={{ opacity: 0, scale: 1.05 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ duration: 1.2, ease: [0.16, 1, 0.3, 1], delay: 0.35 }}
              className="relative aspect-video w-full overflow-hidden border border-border-soft bg-ink"
            >
              <iframe
                data-testid="hero-video"
                className="absolute inset-0 h-full w-full"
                src={`https://www.youtube.com/embed/${N.video.featured}?rel=0`}
                title={HERO.caption}
                loading="lazy"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowFullScreen
              />
            </motion.div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
